import dayjs from "dayjs";
import { initI18nDate } from "./initI18nDate";
import { languages as testLangs } from "./test-utils/trumpfLocales";

describe("initI18nDate", () => {
    testLangs.forEach((lang) => {
        it(`should load i18n resource and set daysjs locale for [${lang}]`, async () => {
            await initI18nDate(lang);
            expect(dayjs.locale()).toEqual(lang);
        });
    });

    it(`should switch locale without loading i18n resource for already loaded locales`, async () => {
        await initI18nDate("en");
        expect(dayjs.locale()).toEqual("en");
        await initI18nDate("de");
        expect(dayjs.locale()).toEqual("de");
    });

    it(`should keep last locale if the locale format is invalid`, async () => {
        await initI18nDate("en");
        await initI18nDate("0");
        expect(dayjs.locale()).toEqual("en");
    });

    it(`should keep last locale if no I18n resource exists for the locale`, async () => {
        await initI18nDate("de");
        await initI18nDate("zz");
        expect(dayjs.locale()).toEqual("de");
    });
});
